import {Layout} from 'antd';
import {Sidebar} from "./sidebar/sidebar";
import {api} from "@/lib/api/api";
import {signOut, useSession} from "next-auth/react";
import {useEffect, useState} from "react";
import {myLinks} from "@/lib/routes/myLinks";

export const MainLayout = ({children}) => {
    const {status, data} = useSession()
    const [isSetToken, setIsSetToken] = useState(false)

    useEffect(()=>{
        if (status === 'unauthenticated'){
            signOut({callbackUrl: myLinks.getUlr('sign-in')})
        }
        if (status === 'authenticated' && !isSetToken){
            api.setToken(data.accessToken, data.remember)
            setIsSetToken(true)
        }
    }, [status])

    return (
        <Layout
            className={'main'}
            hasSider
        >
            {(isSetToken) && (
                <>
                    <Sidebar />
                    <Layout>
                        <Layout.Content
                            className={'main_content'}
                        >
                            {children}
                        </Layout.Content>
                    </Layout>
                </>
            )}
        </Layout>
    );
}
